// extracted by mini-css-extract-plugin
export default {"root":"RZ8bcGg0OJRFoS9WV_D3","header":"BKl5SyPkCKh8qh9ZsOa8","content":"J1n_GJzUbwGIHWJh8RMG","button":"sBgpVxARyj07QGszbRzX","placeHolderShimmer":"eRqmgDHTKsiXsaZMTr3B"};